"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const LogManager_1 = require("../../Log/LogManager");
const IFudaoPassportService_1 = require("../IFudaoPassportService");
const FudaoUser_1 = require("../FudaoUser");
class FudaoPassportService {
    constructor(passportServiceUri) {
        this._logger = LogManager_1.logManager.GetLogger("FudaoClientApplicationServiceBase");
        this._passportServiceUri = passportServiceUri;
    }
    async QueryFudaoUser(userId) {
        if (!userId)
            throw new IFudaoPassportService_1.FudaoPassportServiceError('userId should not be empty');
        const requestUri = `/api/users/${userId}`;
        const completeUri = `${this._passportServiceUri}${requestUri}`;
        this._logger.debug(`query fudaouser from ${completeUri}`);
        const res = await fetch(completeUri, {
            method: 'GET',
        });
        if (!res.ok)
            throw new IFudaoPassportService_1.FudaoPassportServiceError(`Failed to QueryFudaoUser, reason: GET ${completeUri} failed with ${res.status}, ${res.statusText}`);
        const resultJson = await res.json();
        if (!resultJson.success)
            throw new IFudaoPassportService_1.FudaoPassportServiceError(`Failed to QueryFudaoUser, reason: Passport service return success=${resultJson.success}`);
        const profile = resultJson.profile;
        return this.MakeFudaoUserFromUserProfile(profile);
    }
    MakeFudaoUserFromUserProfile(profile) {
        const id = profile["_id"] || "";
        const username = profile["username"] || "";
        const suspension = profile["suspension"] || false;
        const avatar = profile["avatar"] || "";
        const displayname = profile["nickname"] || username;
        const isOnlineStr = profile["presence"] || "";
        const isOnline = isOnlineStr.toLowerCase() === "Online".toLowerCase();
        const status = isOnline ? FudaoUser_1.FudaoUserStatus.Online : FudaoUser_1.FudaoUserStatus.Offline;
        const roles = profile["roles"] || [];
        return new FudaoUser_1.FudaoUser({
            Id: id,
            Name: username,
            Roles: roles,
            Suspension: suspension,
            Status: status,
            Avatar: avatar,
            DisplayName: displayname,
        });
    }
}
exports.FudaoPassportService = FudaoPassportService;
//# sourceMappingURL=FudaoPassportService.js.map